import "./OurPortfolio.css";
import React, { useState } from "react";
import image1 from "../assests/images/portfolio_1.png";
import image2 from "../assests/images/portfolio_2.png";
import image3 from "../assests/images/portfolio_3.png";
import image4 from "../assests/images/portfolio_4.png";
import image5 from "../assests/images/portfolio_5.png";
import image6 from "../assests/images/portfolio_6.png";
import ishkaranSinghBhandari from "../assests/images/portfolio/ishkaran_singh_bhandari.png";
import startupStairs from "../assests/images/portfolio/startup_stairs_logo.jpg";
import dronePlanet from "../assests/images/portfolio/drone_planet_logo.jpeg";
import ramesth from "../assests/images/portfolio/ramesht_logo.png";
import impc from "../assests/images/portfolio/impc_logo.png";
import elephTech from "../assests/images/portfolio/eleph_tech_logo.png";
import iplIcon1 from "../assests/images/portfolio/ipl_icon_1.png";
import iplIcon2 from "../assests/images/portfolio/ipl_icon_2.png";
import iplIcon3 from "../assests/images/portfolio/ipl_icon_3.png";
import iplLogo from "../assests/images/portfolio/ipl_logo.jpg";
import wplLogo from "../assests/images/portfolio/wpl_logo.webp";
import wplIcon2 from "../assests/images/portfolio/wpl_icon_2.png";
import wplIcon3 from "../assests/images/portfolio/wpl_icon_3.png";
import pikaballIcon1 from "../assests/images/portfolio/pikaball_icon_1.png";
import pikaballIcon2 from "../assests/images/portfolio/pikaball_icon_2.png";
import pikaballIcon3 from "../assests/images/portfolio/pikaball_icon_3.png";
import pikaballLogo from "../assests/images/portfolio/pikaball_logo.png";
import abrosFootwearIcon2 from "../assests/images/portfolio/abros_footwear_icon_2.png";
import abrosFootwearIcon3 from "../assests/images/portfolio/abros_footwear_icon_3.png";
import abrosFootwearLogo from "../assests/images/portfolio/abros_logo.png";
import houseOfKariIcon3 from "../assests/images/portfolio/house_of_kari_icon_3.png";
import houseOfKariLogo from "../assests/images/portfolio/house_of_kari_logo.png";
import burgerBaeLogo from "../assests/images/portfolio/burger_bae_logo.png";
import burgerBaeIcon1 from "../assests/images/portfolio/burger_bae_icon_1.png";
import burgerBaeIcon2 from "../assests/images/portfolio/burger_bae_icon_2.png";
import noveltyIcon1 from "../assests/images/portfolio/novelty_icon_1.png";
import noveltyIcon2 from "../assests/images/portfolio/novelty_icon_2.png";
import noveltyIcon3 from "../assests/images/portfolio/novelty_icon_3.png";
import novelty_logo from "../assests/images/portfolio/novelty_logo.png";
import affinity_logo from "../assests/images/portfolio/affinity_logo.png";

const OurPortfolio = () => {
  const [activeCategory, setActiveCategory] = useState("all");
  const [viewMorePortfolio, setViewMorePortfolio] = useState(false);

  const portfolioItems = [
    {
      id: 1,
      category: "web-design",
      image: image1, // Purple Cloud
    },
    {
      id: 2,
      category: "mobile-applications",
      image: image2, // Blue Violet Mobile
    },
    {
      id: 3,
      category: "web-design",
      image: image3, // Dark Slate Blue Snowboarder
    },
    {
      id: 4,
      category: "typography",
      image: image4, // Medium Purple Cloud Head
    },
    {
      id: 5,
      category: "mobile-applications",
      image: image5, // Navy Colorful Blocks
    },
    {
      id: 6,
      category: "typography",
      image: image6, // Purple Kayaker
    },
  ];

  const filteredItems = portfolioItems.filter((item) =>
    activeCategory === "all" ? true : item.category === activeCategory
  );

  const viewMore = () => {
    setViewMorePortfolio(!viewMorePortfolio);
  };

  return (
    <>
      <div className="container mt-200 mb-150">
        <div className="portfolio-header">
          {/* <h1 className="portfolio-title title-text text-center">
            Our Amazing Portfolio
          </h1> */}
        </div>
        <div className="row shadow p-5 mt-5">
          <div className="col-md-4 col-12 d-flex d-sm-none justify-content-center align-items-center">
            <img
              className="portfolio-img shadow"
              src={startupStairs}
              alt=""
            ></img>
          </div>
          <div className="col-md-8 col-12 px-5">
            <h1 className="text-center fs-1 fw-bold title-text">
              STARTUP STAIRS
            </h1>
            <h1 className="subtitle-text text-center mt-4">
              We helped Startup Stairs cut through jargon with humor and
              practicality, making startup advice friendly and founder-first.
            </h1>
            <div className="row mt-5">
              <div className="col-md-4 col-12 text-center">
                <i class="bi bi-megaphone-fill text-warning portfolio-stats-img col-12"></i>
                <p className="col-12 text-center p-0">
                  Platform-specific content across Instagram, LinkedIn,
                  Facebook, and YouTube
                </p>
              </div>
              <div className="col-md-4 col-12 text-center">
                <i className="bi bi-instagram instagram-gradient portfolio-stats-img col-12"></i>
                <p className="col-12 text-center p-0">
                  High traction on reels,{" "}
                  <span className="fw-bold">#StartupDecoded</span>,{" "}
                  <span className="fw-bold">#MythBusted</span>
                </p>
              </div>
              <div className="col-md-4 col-12 text-center">
                <i class="bi bi-patch-check-fill text-success portfolio-stats-img col-12"></i>
                <p className="col-12 text-center p-0">
                  Preet Sandhu's face-forward branding drove trust
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-12 d-none d-sm-flex justify-content-center align-items-center">
            <img
              className="portfolio-img shadow"
              src={startupStairs}
              alt=""
            ></img>
          </div>
        </div>

        <div className="row shadow p-5 mt-5">
          <div className="col-md-4 col-12 d-flex justify-content-center align-items-center">
            <img
              className="portfolio-img shadow"
              src={dronePlanet}
              alt=""
            ></img>
          </div>
          <div className="col-md-8 col-12 px-5">
            <h1 className="text-center fs-1 fw-bold title-text">
              DRONE PLANET
            </h1>
            <h1 className="subtitle-text text-center mt-4">
              From podcasts to precision tech explainers, we positioned Drone
              Planet as the go-to platform for drone solutions.
            </h1>
            <div className="row mt-5">
              <div className="col-md-4 col-12 text-center">
                <i className="bi bi-youtube text-danger portfolio-stats-img col-12"></i>
                <p className="col-12 text-center p-0">
                  40+ YouTube videos
                  <br />
                  (long and short form)
                </p>
              </div>
              <div className="col-md-4 col-12 text-center">
                <i class="bi bi-mic-fill instagram-gradient portfolio-stats-img col-12"></i>
                <p className="col-12 text-center p-0">3 Original Podcast IPs</p>
              </div>
              <div className="col-md-4 col-12 text-center">
                <i class="bi bi-file-text engagement-gradient portfolio-stats-img col-12"></i>
                <p className="col-12 text-center p-0">
                  Drone Proposal Deck for B2B outreach
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="row shadow p-5 mt-5">
          <div className="col-md-4 col-12 d-flex d-sm-none justify-content-center align-items-center">
            <img className="portfolio-img shadow" src={impc} alt=""></img>
          </div>
          <div className="col-md-8 col-12 px-5">
            <h1 className="text-center fs-1 fw-bold title-text">IMPC</h1>
            <h1 className="subtitle-text text-center mt-4">
              We led a multi-city spiritual campaign blending tradition with
              tech — from trends to temples.
            </h1>
            <div className="row mt-5">
              <div className="col-md-4 col-12 text-center">
                <i class="bi bi-megaphone-fill text-warning portfolio-stats-img col-12"></i>
                <p className="col-12 text-center p-0">
                  264M+ views | 14.5M+ reach 288K+ interactions
                </p>
              </div>
              <div className="col-md-4 col-12 text-center">
                <i className="bi bi-twitter instagram-gradient portfolio-stats-img col-12"></i>
                <p className="col-12 text-center p-0">
                  Top 3 Twitter trend (Shiv Shakti Mahapoojan)
                </p>
              </div>
              <div className="col-md-4 col-12 text-center">
                <i class="bi bi-patch-check-fill text-success portfolio-stats-img col-12"></i>
                <p className="col-12 text-center p-0">
                  Kailash Kher-led celebrity integration
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-12 d-none d-sm-flex justify-content-center align-items-center">
            <img className="portfolio-img shadow" src={impc} alt=""></img>
          </div>
        </div>

        {viewMorePortfolio === true && (
          <div>
            <div className="row shadow p-5 mt-5">
              <div className="col-md-4 col-12 d-flex justify-content-center align-items-center">
                <img
                  className="portfolio-img shadow"
                  src={ramesth}
                  alt=""
                ></img>
              </div>
              <div className="col-md-8 col-12 px-5">
                <h1 className="text-center fs-1 fw-bold title-text">Ramesth</h1>
                <h1 className="subtitle-text text-center mt-4">
                  We launched Ramesth as a soulful spiritual brand — blending
                  divine aroma with digital finesse
                </h1>
                <div className="row mt-5">
                  <div className="col-md-4 col-12 text-center">
                    <i class="bi bi-bag text-warning portfolio-stats-img col-12"></i>
                    <p className="col-12 text-center p-0">
                      Full branding, Shopify website, and Amazon setup
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <i className="bi bi-instagram instagram-gradient portfolio-stats-img col-12"></i>
                    <p className="col-12 text-center p-0">
                      Reels with Rasraj Ji Maharaj driving storytelling
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <i class="bi bi-receipt text-success portfolio-stats-img col-12"></i>
                    <p className="col-12 text-center p-0">
                      First organic sale within weeks
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row shadow p-5 mt-5">
              <div className="col-md-4 col-12 d-sm-none d-flex justify-content-center align-items-center">
                <img
                  style={{ objectFit: "contain", objectPosition: "center" }}
                  className="portfolio-img shadow"
                  src={elephTech}
                  alt=""
                ></img>
              </div>
              <div className="col-md-8 col-12 px-5">
                <h1 className="text-center fs-1 fw-bold title-text">Eleph</h1>
                <h1 className="subtitle-text text-center mt-4">
                  We positioned Eleph as the sleek intersection of tech and
                  lifestyle — not just functionality.
                </h1>
                <div className="row mt-5">
                  <div className="col-md-4 col-12 text-center">
                    <i class="bi bi-instagram instagram-gradient text-warning portfolio-stats-img col-12"></i>
                    <p className="col-12 text-center p-0">
                      Instagram-first visual storytelling
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <i className="bi text-danger bi-view-stacked portfolio-stats-img col-12"></i>
                    <p className="col-12 text-center p-0">
                      Viral meme reels and design-led grid
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <i class="bi bi-lightning-charge-fill text-warning text-success portfolio-stats-img col-12"></i>
                    <p className="col-12 text-center p-0">
                      Qualified sales leads via direct messages
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-12 d-none d-sm-flex justify-content-center align-items-center">
                <img
                  style={{ objectFit: "contain", objectPosition: "center" }}
                  className="portfolio-img shadow"
                  src={elephTech}
                  alt=""
                ></img>
              </div>
            </div>

            <div className="row shadow p-5 mt-5">
              <div className="col-md-4 col-12 d-flex justify-content-center align-items-center">
                <img
                  className="portfolio-img shadow"
                  src={iplLogo}
                  alt=""
                ></img>
              </div>
              <div className="col-md-8 col-12 px-5">
                <h1 className="text-center fs-1 fw-bold title-text">
                  IPL 2025
                </h1>
                <h3 className="text-center fs-5 title-text">
                  When Stadiums Became Shows
                </h3>
                <h1 className="subtitle-text text-center mt-4">
                  We turned IPL 2025 playoffs into an immersive entertainment
                  spectacle for fans.
                </h1>
                <div className="row mt-5">
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={iplIcon1}
                    ></img>
                    <p className="col-12 text-center p-0">
                      AI photo booth, live crowd games, and fan cams
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={iplIcon2}
                    ></img>
                    <p className="col-12 text-center p-0">
                      Real-time videography and match-up creatives
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={iplIcon3}
                    ></img>
                    <p className="col-12 text-center p-0">
                      Post-match highlight reels capturing crowd energy
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row shadow p-5 mt-5">
              <div className="col-md-4 col-12 d-sm-none d-flex justify-content-center align-items-center">
                <img
                  className="portfolio-img shadow"
                  src={wplLogo}
                  alt=""
                ></img>
              </div>
              <div className="col-md-8 col-12 px-5">
                <h1 className="text-center fs-1 fw-bold title-text">WPL</h1>
                <h3 className="text-center fs-5 title-text">
                  Women’s Premier League
                </h3>
                <h3 className="text-center fs-5 title-text">
                  Lighting Up the Rise of Women’s Cricket
                </h3>
                <h1 className="subtitle-text text-center mt-4">
                  We amplified the WPL stadium vibe with tech, content, and
                  engagement — celebrating women’s cricket with flair.
                </h1>
                <div className="row mt-5">
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={iplIcon2}
                    ></img>
                    <p className="col-12 text-center p-0">
                      On-ground team and live engagement coordination
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={wplIcon2}
                    ></img>
                    <p className="col-12 text-center p-0">
                      Stadium animations, trivia, and scoreboard visuals
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={wplIcon3}
                    ></img>
                    <p className="col-12 text-center p-0">
                      Branded energy through visuals and chants
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-12 d-none d-sm-flex justify-content-center align-items-center">
                <img
                  className="portfolio-img shadow"
                  src={wplLogo}
                  alt=""
                ></img>
              </div>
            </div>

            <div className="row shadow p-5 mt-5">
              <div className="col-md-4 col-12 d-flex justify-content-center align-items-center">
                <img
                  style={{ objectFit: "contain", objectPosition: "center" }}
                  className="portfolio-img shadow"
                  src={pikaballLogo}
                  alt=""
                ></img>
              </div>
              <div className="col-md-8 col-12 px-5">
                <h1 className="text-center fs-1 fw-bold title-text">
                  PikAball
                </h1>
                <h3 className="text-center fs-5 title-text">
                  India’s Fastest Growing Pickleball Movement
                </h3>
                <h1 className="subtitle-text text-center mt-4 text-center">
                  From identity to action, we built PikAball into a vibrant,
                  inclusive sports lifestyle brand.
                </h1>
                <div className="row mt-5">
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={pikaballIcon1}
                    ></img>
                    <p className="col-12 text-center p-0">
                      Neon-themed Instagram with 4K+ organic followers
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={pikaballIcon2}
                    ></img>
                    <p className="col-12 text-center p-0">
                      Website, smart booking system, and B2B partner flow
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={pikaballIcon3}
                    ></img>
                    <p className="col-12 text-center p-0">
                      Community-driven events like #NeonNights and Court of the
                      Week
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row shadow p-5 mt-5">
              <div className="col-md-4 col-12 d-flex d-sm-none justify-content-center align-items-center">
                <img
                  style={{ objectFit: "contain", objectPosition: "center" }}
                  className="portfolio-img shadow"
                  src={abrosFootwearLogo}
                  alt=""
                ></img>
              </div>
              <div className="col-md-8 col-12 px-5">
                <h1 className="text-center fs-1 fw-bold title-text">
                  Abros Footwear
                </h1>
                <h1 className="subtitle-text text-center mt-4 text-center">
                  From Budget to Aspirational Streetwear
                </h1>
                <div className="row mt-5">
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={pikaballIcon1}
                    ></img>
                    <p className="col-12 text-center p-0">
                      Built bold, Gen-Z focused visual identity on Instagram
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={abrosFootwearIcon2}
                    ></img>
                    <p className="col-12 text-center p-0">
                      Grew followers from 5K to 25K+ organically in 1 year
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={abrosFootwearIcon3}
                    ></img>
                    <p className="col-12 text-center p-0">
                      Leveraged Reels + moment marketing for sports & culture
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-12 d-none d-sm-flex justify-content-center align-items-center">
                <img
                  style={{ objectFit: "contain", objectPosition: "center" }}
                  className="portfolio-img shadow"
                  src={abrosFootwearLogo}
                  alt=""
                ></img>
              </div>
            </div>

            <div className="row shadow p-5 mt-5">
              <div className="col-md-4 col-12 d-flex justify-content-center align-items-center">
                <img
                  style={{ objectFit: "contain", objectPosition: "center" }}
                  className="portfolio-img shadow"
                  src={houseOfKariLogo}
                  alt=""
                ></img>
              </div>
              <div className="col-md-8 col-12 px-5">
                <h1 className="text-center fs-1 fw-bold title-text">
                  House of Kari
                </h1>
                <h1 className="subtitle-text text-center mt-4 text-center">
                  Everyday Ethnicwear with Soul
                </h1>
                <div className="row mt-5">
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={pikaballIcon1}
                    ></img>
                    <p className="col-12 text-center p-0">
                      Created earthy, elegant visual tone with real-women
                      storytelling
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={pikaballIcon2}
                    ></img>
                    <p className="col-12 text-center p-0">
                      Content buckets like #KariLookbook & #BehindTheSeams drove
                      engagement
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={houseOfKariIcon3}
                    ></img>
                    <p className="col-12 text-center p-0">
                      Influencer-led festive campaigns amplified organic growth
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row shadow p-5 mt-5">
              <div className="col-md-4 col-12 d-flex d-sm-none justify-content-center align-items-center">
                <img
                  style={{ objectFit: "contain", objectPosition: "center" }}
                  className="portfolio-img shadow"
                  src={burgerBaeLogo}
                  alt=""
                ></img>
              </div>
              <div className="col-md-8 col-12 px-5">
                <h1 className="text-center fs-1 fw-bold title-text">
                  Burger Bae
                </h1>
                <h1 className="subtitle-text text-center mt-4 text-center">
                  Where Food Meets Gen-Z Chaos
                </h1>
                <div className="row mt-5">
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={burgerBaeIcon1}
                    ></img>
                    <p className="col-12 text-center p-0">
                      Revamped tone with wit, memes, and messy burger reels
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={burgerBaeIcon2}
                    ></img>
                    <p className="col-12 text-center p-0">
                      BTS content humanized the brand
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={pikaballIcon1}
                    ></img>
                    <p className="col-12 text-center p-0">
                      Viral Reels (1M+ views) and foodie collabs boosted
                      visibility
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-12 d-none d-sm-flex justify-content-center align-items-center">
                <img
                  style={{ objectFit: "contain", objectPosition: "center" }}
                  className="portfolio-img shadow"
                  src={burgerBaeLogo}
                  alt=""
                ></img>
              </div>
            </div>

            <div className="row shadow p-5 mt-5">
              <div className="col-md-4 col-12 d-flex justify-content-center align-items-center">
                <img
                  style={{ objectFit: "contain", objectPosition: "center" }}
                  className="portfolio-img shadow"
                  src={novelty_logo}
                  alt=""
                ></img>
              </div>
              <div className="col-md-8 col-12 px-5">
                <h1 className="text-center fs-1 fw-bold title-text">
                  Novelty Dairy
                </h1>
                <h1 className="subtitle-text text-center mt-4 text-center">
                  Quirky Twist on Everyday Dairy
                </h1>
                <div className="row mt-5">
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={noveltyIcon1}
                    ></img>
                    <p className="col-12 text-center p-0">
                      Hinglish content + CGI visuals for dahi, milk, paneer
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={noveltyIcon2}
                    ></img>
                    <p className="col-12 text-center p-0">
                      Introduced “Taste Ka Tadka” & festive moment marketing
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={noveltyIcon3}
                    ></img>
                    <p className="col-12 text-center p-0">
                      Polls, quizzes, giveaways drove community interaction
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row shadow p-5 mt-5">
              <div className="col-md-4 col-12 d-sm-none d-flex justify-content-center align-items-center">
                <img
                  style={{
                    objectFit: "contain",
                    objectPosition: "center",
                    backgroundColor: "black",
                  }}
                  className="portfolio-img shadow"
                  src={affinity_logo}
                  alt=""
                ></img>
              </div>
              <div className="col-md-8 col-12 px-5">
                <h1 className="text-center fs-1 fw-bold title-text">
                  Affinity Salon
                </h1>
                <h1 className="subtitle-text text-center mt-4 text-center">
                  Luxury Made Digital
                </h1>
                <div className="row mt-5">
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={pikaballIcon1}
                    ></img>
                    <p className="col-12 text-center p-0">
                      Visual revamp with clean, elegant feed design
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={pikaballIcon2}
                    ></img>
                    <p className="col-12 text-center p-0">
                      Branded content buckets: Glow Ups, Bridal Diaries, Expert
                      Tips
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <img
                      alt=""
                      width="50px"
                      height="50px"
                      className="portfolio-stats-img"
                      src={houseOfKariIcon3}
                    ></img>
                    <p className="col-12 text-center p-0">
                      Influencer GRWM, pamper day reels boosted bookings
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-12 d-sm-flex d-none justify-content-center align-items-center">
                <img
                  style={{
                    objectFit: "contain",
                    objectPosition: "center",
                    backgroundColor: "black",
                  }}
                  className="portfolio-img shadow"
                  src={affinity_logo}
                  alt=""
                ></img>
              </div>
            </div>

            <div className="row shadow p-5 mt-5">
              <div className="col-md-4 col-12 d-flex justify-content-center align-items-center">
                <img
                  className="portfolio-img shadow"
                  src={ishkaranSinghBhandari}
                  alt=""
                ></img>
              </div>
              <div className="col-md-8 col-12 px-5">
                <h1 className="text-center fs-1 fw-bold title-text">
                  ISHKARAN SINGH BHANDARI
                </h1>
                <h1 className="subtitle-text text-center mt-4">
                  Anushthan transformed Ishkaran Singh Bhandari's digital
                  persona into a powerhouse of legal, political, and dharmic
                  commentary.
                </h1>
                <div className="row mt-5">
                  <div className="col-md-4 col-12 text-center">
                    <i className="bi bi-youtube text-danger portfolio-stats-img col-12"></i>
                    <p className="col-12 text-center p-0">
                      28 content pieces
                      <br />
                      (20 reels, 6 YouTube videos)
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <i className="bi bi-instagram instagram-gradient portfolio-stats-img col-12"></i>
                    <p className="col-12 text-center p-0">
                      Top reel: 80K+ views on celebrity case bust
                    </p>
                  </div>
                  <div className="col-md-4 col-12 text-center">
                    <i className="bi bi-chat-dots-fill text-danger engagement-gradient portfolio-stats-img col-12"></i>
                    <p className="col-12 text-center p-0">
                      Average engagement rate: 5.6%
                      <br />
                      (above niche average)
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="row justify-content-center mt-5">
          <button
            onClick={viewMore}
            className="btn btn-warning col-md-2 col-4 text-black fw-bolder"
          >
            {viewMorePortfolio ? `View Less` : "View More"}
          </button>
        </div>
      </div>
    </>
  );
};

export default OurPortfolio;
